/* istanbul ignore file */
import React from 'react'
// @ts-ignore no types
import {
  Grid,
  // @ts-ignore no types
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { useListingContext } from '../../../../common/context/listing'
import SectionPanel from '../../../components/sectionPanel'
import PropertyDetailsRow from './propertyDetailsRow'
// @ts-ignore no types
import cls from './index.scss'

const cx = classnames.bind(cls)

const PropertyDetails = () => {
  const { listing } = useListingContext()
  const isFirstLookEnabled =
    listing?.listing_configuration?.is_first_look_enabled

  return (
    <SectionPanel title='Property Details' elmId='property_details'>
      <Grid>
        <Grid.Column
          computer={16}
          tablet={16}
          mobile={16}
          className={cx({ 'property-details-container': isFirstLookEnabled })}
        >
          <PropertyDetailsRow listing={listing} />
        </Grid.Column>
      </Grid>
    </SectionPanel>
  )
}
export default PropertyDetails
